import { lazy } from "react";
import GlofasEventsPage from "./apps/glofas/get-involved/GlofasEventsPage.tsx";
import EventDetail from "./apps/glofas/get-involved/apps/events/EventDetail.tsx";
import GlofasNewsPage from "./apps/glofas/news/GlofasNewsPage.tsx";
import DssCountryComponent from "./apps/glofas/dss/DssCountryComponent.tsx";

const NewsDetail = lazy(() => import('./apps/efas/news/NewsDetail.tsx'));
const CarouselHistory = lazy(() => import('./apps/glofas/CarouselHistory.tsx'));

export const GLOFAS_ROUTES = [
    {
        path: "dss/countries",
        element: <DssCountryComponent />,
    },
    {
        path: "news",
        children: [
            {
                index: true,
                element: <GlofasNewsPage />,
            },
            {
                path: ":detail_slug",
                element: <NewsDetail />,
                loader: async ({ params }: { params: Record<string, string> }) => {
                    return fetch(`/api/news/${params.detail_slug}`);
                },
            }
        ]
    },
    {
        path: "get-involved/events",
        children: [
            {
                index: true,
                element: <GlofasEventsPage />,
            },
            {
                path: ":eventId",
                element: <EventDetail />,
                loader: async ({ params }: { params: Record<string, string> }) => {
                    const response = await fetch(`/api/events/${params.eventId}`);
                    if (!response.ok) {
                        throw new Error(`Failed to fetch event: ${response.status}`);
                    }
                    return response.json();
                },
            }
        ]
    },
    {
        path: "feedback",
        lazy: async () => {
            const { ContactForm } = await import('./apps/contact/ContactForm.tsx');
            return { Component: ContactForm }
        },
    },
    {
        path: "contact-us",
        lazy: async () => {
            const { ContactForm } = await import('./apps/contact/ContactForm.tsx');
            return { Component: ContactForm }
        },
    },
    {
        path: "terms-of-service",
        lazy: async () => {
            const { TermsOfServicePage } = await import('./apps/contact/TermsOfServicePage.tsx');
            return { Component: TermsOfServicePage }
        },
    },
    {
        path: "privacy",
        lazy: async () => {
            const { PrivacyPage } = await import('./apps/contact/PrivacyPage.tsx');
            return { Component: PrivacyPage }
        },
    },
    {
        path: "hidden/carousel_history",
        element: <CarouselHistory />,
    },
]